import {
    Checkbox,
    CircularProgress,
    FormControlLabel,
    Paper,
    Tab,
    Tabs,
} from "@material-ui/core";
import axios from "axios";
import getSymbolFromCurrency from "currency-symbol-map";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { BsArrowLeftShort, BsCheckCircleFill, BsCircle } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
    addShortlistStone,
    updateShortlistStoneCount,
} from "../../../redux/commonRedux/common.actions";
import { isParsable } from "../../../utils/commonUtils";
import { toAbsoluteUrl, localizePrice, formatCcmodePrice } from "../../_helpers";
import CertificateLink from "../CertificateLink";
import { BuyPopUpNew } from "../popup/BuyPopUpNew";
import DiamondTypeTag from "../popup/DiamondTypeTag";
import { SwalWarn } from "../popup/SwalWarn";
import {
    FETCH_CONSUMER_SHORTLIST_DATA,
    NODE_API_URL,
} from "./../../../env_config";
import OrderHistoryOfActiveSession from "./OrderHistoryOfActiveSession";

function StockStatus({ data }) {
    let statusNode = null;

    if (data.CURRENT_STATUS.status === "success") {
        statusNode = (
            <div className="text-info font-weight-bolder">
                {data.CURRENT_STATUS.message}
            </div>
        );
    } else if (data.CURRENT_STATUS.status === "warning") {
        statusNode = (
            <div className="text-warning font-weight-bolder">
                {data.CURRENT_STATUS.message}
            </div>
        );
    } else {
        statusNode = (
            <div className="text-danger font-weight-bolder">
                {data.CURRENT_STATUS.message}
            </div>
        );
    }

    return statusNode;
}

const isVisibleForCustomer = (customer_country, country) => {
    const isIndianCustomer = customer_country?.toUpperCase() === "INDIA";
    const isIndianCountry = country?.toUpperCase() === "INDIA";
    return isIndianCustomer ? isIndianCountry : true;
};

export const CartDetails = ({ language, ConsumerId }) => {
    const history = useHistory();
    const [selected, setSelected] = React.useState([]);
    const [selectedstones, setSelectedStone] = React.useState([]);
    const [show, setShow] = useState(false);
    const [totalcarat, setTotalCarat] = useState(0);
    const [totalourprice, setTotalOurPrice] = useState(0);
    const [swalWarnOpen, setSwalWarnOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState();
    const [loader, setLoader] = useState(true);
    const userData = useMemo(() => localStorage.getItem("userData"), []);
    const user = JSON.parse(userData);
    const [consumerData, setConsumerData] = useState([]);
    const [availabilitydata, setAvailabilityData] = useState([]);

    const dispatch = useDispatch();
    const shortListedStoneCount = useSelector((state) => {
        return state.ShortlistStoneReducer?.shortlistStoneCount;
    });
    const {
        hidePrice,
        hideCertificateNumber,
        displaybuybtn,
        isBuyRequest,
    } = useSelector((state) => state.CcModeSettingReducer);

    const { planFeatures } = useSelector(
        (state) => state.CcmodePlanFeaturesReducer,
    );
    function Currency(Currency) {
        return getSymbolFromCurrency(Currency);
    }

    useEffect(() => {
        const finalData = `{  "customerId": ${user.CustomerId}, "ConsumerId":${ConsumerId.ConsumerId} }`;
        const getShortListData = async () => {
            axios({
                method: "POST",
                url: `${FETCH_CONSUMER_SHORTLIST_DATA}?removeBuyRequest=true`,
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem(
                        "accessToken",
                    )}`,
                },
                data: finalData,
            })
                .then((res) => {
                    if (res.data.message === "UnAuthorized") {
                        localStorage.clear();
                        window.location.reload(true);
                    }
                    setLoader(false);
                    dispatch(addShortlistStone(res.data.Result));
                    setConsumerData(res.data.Result || []);
                })
                .catch(function(res) {
                    console.log(res);
                });
        };

        getShortListData();
    }, [user.CustomerId, ConsumerId, dispatch]);

    useEffect(() => {
        if (consumerData && consumerData.length) {
            let temptotalcarat = 0;
            let temptotalourprice = 0;
            let filterselect = consumerData
                .filter((value) => {
                    if (selected.includes(value.Certi_No)) {
                        return true;
                    } else {
                        return false;
                    }
                })
                .map((value) => {
                    temptotalcarat += parseFloat(value.C_Weight);
                    temptotalourprice += parseFloat(
                        isParsable(value.SELECTED_CURRENCY_LIST_PRICE)
                            ? value.SELECTED_CURRENCY_LIST_PRICE
                            : 0,
                    );
                    return value;
                });

            setSelectedStone(filterselect);
            setTotalCarat(temptotalcarat);
            setTotalOurPrice(temptotalourprice);
        }
    }, [consumerData, selected]);

    useEffect(() => {
        if (consumerData && consumerData.length) {
            let availibilitycheck = [];
            for (let i = 0; i < consumerData.length; i++) {
                if (consumerData[i]?.status_api_available?.toString() === "1") {
                    availibilitycheck.push({
                        sup_id: consumerData[i]?.sup_id,
                        stoneno: consumerData[i]?.Loat_NO,
                        diamond_type: consumerData[i]?.diamond_type,
                        doc_stock_id: consumerData[i]?.id,
                    });
                }
            }
            if (availibilitycheck.length) {
                let BASEURL = "https://api.staging.global.diamondsupload.com";
                if (
                    process.env.REACT_APP_FETCH_COUNSUMER_LIST ===
                    "https://api.ciccio2.diazoom.com"
                ) {
                    BASEURL = "https://api.global.diamondsoncall.com";
                }
                let config = {
                    method: "post",
                    maxBodyLength: Infinity,
                    url: `${BASEURL}/supplier/getAvailibilityStatus`,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    data: {
                        supplierdata: availibilitycheck,
                    },
                };
                function debounce(func, delay) {
                    let timeoutId;
                    return function(...args) {
                        clearTimeout(timeoutId);
                        timeoutId = setTimeout(() => {
                            func.apply(this, args);
                        }, delay);
                    };
                }
                // Debounced Axios request
                const debouncedRequest = debounce((config) => {
                    axios
                        .request(config)
                        .then((response) => {
                            setLoader(false);
                            if (response?.data?.data) {
                                setAvailabilityData(response?.data?.data);
                            }
                        })
                        .catch((error) => {
                            setLoader(false);
                            console.log(error);
                        });
                }, 300); // 300ms delay
                debouncedRequest(config);
            } else {
                setLoader(false);
            }
        }
    }, [consumerData]);

    const isSelected = (name) => selected.indexOf(name) !== -1;

    const handleClick = useCallback((event, name) => {
        setSelected((prev) =>
            prev.includes(name)
                ? prev.filter((x) => x !== name)
                : [...prev, name],
        );
    }, []);

    const removeDiamond = () => {
        let shortlistedStoneIds = [];
        consumerData.forEach((stone) => {
            if (selected.includes(stone.Certi_No)) {
                return shortlistedStoneIds.push(stone.Id);
            }
        });

        const config = {
            method: "POST",
            url: `${NODE_API_URL}/ccmode/removeShortlistedStone`,
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            data: {
                CustomerId: user.CustomerId,
                Id: shortlistedStoneIds,
            },
        };

        axios(config).then((res) => {
            if (res.data.message === "UnAuthorized") {
                localStorage.clear();
                window.location.reload(true);
            }
            setTotalOurPrice(0);
            setSelectedStone([]);
            setTotalCarat(0);
            setLoader(false);
            setConsumerData(
                consumerData.filter(
                    (elem) => !shortlistedStoneIds.includes(elem.Id),
                ),
            );
            dispatch(
                updateShortlistStoneCount({
                    shortListedStoneCount:
                        shortListedStoneCount - shortlistedStoneIds.length,
                }),
            );
        });
    };

    const BuyDiamond = () => {
        if (!selectedstones.length) {
            setSwalWarnOpen(true);
            setAlertMessage(language.CCMODE_CART_PLEASE_SELECT_AT_LEAST_ONE_STONE);
            return;
        }
        if (
            selectedstones.some(
                (stone) => !isParsable(stone.SELECTED_CURRENCY_LIST_PRICE),
            )
        ) {
            setSwalWarnOpen(true);
            setAlertMessage(
                language.CCMODE_CART_PRICE_ON_REQUEST_NO_BUY ||
                    "Price on request items cannot be purchased. Please deselect them to buy.",
            );
            return;
        }
        let inactive = false;
        for (let i = 0; i < selectedstones.length; i++) {
            let available = true;
            let checkavailable = availabilitydata.find(
                (avvalue) =>
                    avvalue?.stoneno?.toString() ===
                    selectedstones[i].Loat_NO?.toString(),
            );
            if (checkavailable?.status === "UnAvailable") {
                available = false;
            }
            if (selectedstones[i].Status === "1" || !available) {
                inactive = true;
            }
            if (selectedstones[i].isBuyRequested) {
                inactive = true;
            }
        }
        if (inactive) {
            setSwalWarnOpen(true);
            setAlertMessage(language.CCMODE_CART_PLEASE_SELECT_ONLY_ACTIVE_STONES);
            return;
        }
        setShow(true);
    };

    const HandleMultiSelect = (event) => {
        if (event.target.checked) {
            let alldata = consumerData
                .filter((value) => {
                    return isVisibleForCustomer(
                        value.customer_country,
                        value.country,
                    );
                })
                .map((value) => value.Certi_No);
            setSelected(alldata);
        } else {
            setSelected([]);
        }
    };

    const GetPrice = (data) => {
        let markupusdprice = isParsable(data.SELECTED_CURRENCY_LIST_PRICE)
            ? data.SELECTED_CURRENCY_LIST_PRICE
            : 0;
        return markupusdprice;
    };
    const GetPricePerCarat = (data) => {
        let markupusdprice = isParsable(
            data.SELECTED_CURRENCY_LIST_PRICE_PER_CARAT,
        )
            ? data.SELECTED_CURRENCY_LIST_PRICE_PER_CARAT
            : 0;
        return markupusdprice;
    };

    function handelDetails(row) {
        history.push({
            pathname: "/details",
            state: {
                StockID: row.ProductId,
                diamond_type:
                    row.C_Color !== "fancy"
                        ? row.WLDiamondType
                        : row.WLDiamondType + "F",
            },
        });
        window.scrollTo(0, 0);
    }

    const [tab, setTab] = useState("cart");

    function handleTabChange(event, newValue) {
        window.glob = newValue;
        setTab(newValue);
    }
    const backBtn = () => {
        history.push(
            "/searchdiamond",
            JSON.parse(localStorage.getItem("themesearch")),
        );
    };
    const hasPriceOnRequestSelected = selectedstones.some(
        (stone) => !isParsable(stone.SELECTED_CURRENCY_LIST_PRICE),
    );
    return (
        <>
            {!loader ? (
                <>
                    {selectedstones.length ? (
                        <BuyPopUpNew
                            data={selectedstones}
                            language={language}
                            user={user}
                            diamondcount={selectedstones.length}
                            totalpricepercarat={totalourprice / totalcarat}
                            totalourprice={totalourprice}
                            Currency={localStorage.getItem("user_currency")}
                            setShow={setShow}
                            show={show}
                            GetPricePerCarat={GetPricePerCarat}
                            GetPrice={GetPrice}
                            symbol={Currency(
                                localStorage.getItem("user_currency"),
                            )}
                        />
                    ) : (
                        ""
                    )}
                    <SwalWarn
                        show={swalWarnOpen}
                        message={alertMessage}
                        onClose={() => setSwalWarnOpen(false)}
                    />
                    <Paper position="static" className="mb-3">
                        <Tabs value={tab} onChange={handleTabChange}>
                            <Tab label={language.CCMODE_CART_CART} value="cart" />
                            <Tab label={language.CCMODE_CART_ORDER_HISTORY} value="order-history" />
                        </Tabs>
                    </Paper>
                    {tab === "cart" ? (
                        consumerData.length > 0 ? (
                            <div className="row natTab">
                                <div className="col-md-8">
                                    <div className="card card-custom">
                                        <div className="card-header ">
                                            <div className="card-title align-items-start mt-3 flex-column">
                                                <div
                                                    className="cursor-pointer text-hover-primary font-size-h6"
                                                    onClick={backBtn}
                                                >
                                                    <BsArrowLeftShort />{" "}
                                                    {language.CCMODE_CART_GO_TO_SEARCH_RESULTS}
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={
                                                                    selectedstones.length &&
                                                                    selectedstones.length ===
                                                                        consumerData.filter(
                                                                            (
                                                                                value,
                                                                            ) => {
                                                                                return isVisibleForCustomer(
                                                                                    value.customer_country,
                                                                                    value.country,
                                                                                );
                                                                            },
                                                                        ).length
                                                                }
                                                                className="mb-0"
                                                                inputProps={{
                                                                    "aria-labelledby":
                                                                        "enhanced-table-checkbox",
                                                                }}
                                                                onClick={(
                                                                    event,
                                                                ) =>
                                                                    HandleMultiSelect(
                                                                        event,
                                                                    )
                                                                }
                                                                icon={
                                                                    <BsCircle />
                                                                }
                                                                checkedIcon={
                                                                    <BsCheckCircleFill />
                                                                }
                                                            />
                                                        }
                                                        className="mb-0 mt-1"
                                                        label={language.CCMODE_CART_SELECT_ALL}
                                                    />

                                                    <div>
                                                        {" "}
                                                        {consumerData
                                                            ? consumerData.filter(
                                                                  (value) => {
                                                                      if (
                                                                          selected.includes(
                                                                              value.Certi_No,
                                                                          )
                                                                      ) {
                                                                          return true;
                                                                      } else {
                                                                          return false;
                                                                      }
                                                                  },
                                                              ).length
                                                            : 0}{" "}
                                                        {language.CCMODE_CART_DIAMONDS_IN_CART}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-toolbar">
                                                <button
                                                    onClick={() =>
                                                        removeDiamond()
                                                    }
                                                    className="btn font-weight-bold btn-primary mt-2"
                                                >
                                                    {language.CCMODE_CART_REMOVE_FROM_CART}
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div
                                                className="custom-scrollbar w-100"
                                                style={{
                                                    maxHeight: "63vh",
                                                    position: "relative",
                                                }}
                                            >
                                                {consumerData ? (
                                                    consumerData.map(
                                                        (data, index) => {
                                                            const isItemSelected = isSelected(
                                                                data.Certi_No,
                                                            );
                                                            const labelId = `enhanced-table-checkbox-${index}`;

                                                            return (
                                                                <div
                                                                    className={`d-flex align-items-start justify-content-start ${
                                                                        isVisibleForCustomer(
                                                                            data.customer_country,
                                                                            data.country,
                                                                        )
                                                                            ? null
                                                                            : "outofstock-box"
                                                                    }`}
                                                                >
                                                                    <Checkbox
                                                                        checked={
                                                                            isItemSelected
                                                                        }
                                                                        className="inactive-block"
                                                                        inputProps={{
                                                                            "aria-labelledby": labelId,
                                                                        }}
                                                                        onClick={(
                                                                            event,
                                                                        ) =>
                                                                            handleClick(
                                                                                event,
                                                                                data.Certi_No,
                                                                            )
                                                                        }
                                                                        icon={
                                                                            <BsCircle />
                                                                        }
                                                                        checkedIcon={
                                                                            <BsCheckCircleFill />
                                                                        }
                                                                        disabled={
                                                                            !isVisibleForCustomer(
                                                                                data.customer_country,
                                                                                data.country,
                                                                            )
                                                                        }
                                                                    />
                                                                    <div
                                                                        key={
                                                                            data.ProductId
                                                                        }
                                                                        className="d-flex w-100 mb-2 pb-1 px-4 border-bottom justify-content-between"
                                                                    >
                                                                        <div className="d-flex">
                                                                            <div className="text-center p-0 inactive-block">
                                                                                {data.AWS_Image &&
                                                                                data.AWS_Image !==
                                                                                    "null" ? (
                                                                                    <img
                                                                                        className="img-fluid mr-2 cursor-pointer"
                                                                                        alt={
                                                                                            data.C_Shape
                                                                                        }
                                                                                        src={
                                                                                            data.AWS_Image
                                                                                        }
                                                                                        onError={(
                                                                                            e,
                                                                                        ) => {
                                                                                            e.currentTarget.src =
                                                                                                data?.sample;
                                                                                        }}
                                                                                        onClick={() =>
                                                                                            handelDetails(
                                                                                                data,
                                                                                            )
                                                                                        }
                                                                                        width="115px"
                                                                                    />
                                                                                ) : (
                                                                                    <img
                                                                                        className="img-fluid mr-2"
                                                                                        alt={
                                                                                            data.C_Shape
                                                                                        }
                                                                                        src={
                                                                                            data?.sample
                                                                                        }
                                                                                        onError={(
                                                                                            e,
                                                                                        ) => {
                                                                                            e.currentTarget.src = toAbsoluteUrl(
                                                                                                `/media/shape/noimage.png`,
                                                                                            );
                                                                                        }}
                                                                                        width="115px"
                                                                                        onClick={() =>
                                                                                            handelDetails(
                                                                                                data,
                                                                                            )
                                                                                        }
                                                                                        style={{
                                                                                            backgroundColor:
                                                                                                "#f4f4f4",
                                                                                        }}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                            <div className="pl-2 p-0 text-left">
                                                                                <div
                                                                                    className={`mb-1 ${
                                                                                        data.WLDiamondType ===
                                                                                        "L"
                                                                                            ? "labTab"
                                                                                            : data.WLDiamondType ===
                                                                                              "N"
                                                                                            ? "natTab"
                                                                                            : ""
                                                                                    } inactive-block`}
                                                                                >
                                                                                    <DiamondTypeTag
                                                                                        diamondTypeTagColor={
                                                                                            data.diamondTypeTagColor
                                                                                        }
                                                                                        diamondTypeTag={
                                                                                            data.diamondTypeTag
                                                                                        }
                                                                                    />
                                                                                    <span
                                                                                        className={`text-primary font-weight-bold small ml-1`}
                                                                                    >
                                                                                        {data.WLDiamondType ===
                                                                                        "N"
                                                                                            ? "N"
                                                                                            : "L"}

                                                                                        -
                                                                                        {
                                                                                            data.ProductId
                                                                                        }
                                                                                    </span>
                                                                                    {hideCertificateNumber ? (
                                                                                        ""
                                                                                    ) : (
                                                                                        // <CertificateLink
                                                                                        //     Certificate_link={
                                                                                        //         data.CERTIFICATE_LINK
                                                                                        //     }
                                                                                        //     lab={
                                                                                        //         data.Lab
                                                                                        //     }
                                                                                        //     certificate={
                                                                                        //         data.Certi_No
                                                                                        //     }
                                                                                        //     className={`text-primary font-weight-bold mx-2 small`}
                                                                                        // />
                                                                                        <CertificateLink
                                                                                            Certificate_link={
                                                                                                data.CERTIFICATE_LINK
                                                                                            }
                                                                                            lab={
                                                                                                data.Lab
                                                                                            }
                                                                                            certificate={
                                                                                                data.Certi_NO
                                                                                            }
                                                                                            className={`text-primary font-weight-bold mx-2 small`}
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                                <span
                                                                                    className="text-dark font-size-lg mb-2 font-weight-bold d-block inactive-block cursor-pointer"
                                                                                    onClick={() =>
                                                                                        handelDetails(
                                                                                            data,
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        data.C_Shape
                                                                                    }{" "}
                                                                                    {data.C_Weight
                                                                                        ? parseFloat(
                                                                                              data.C_Weight,
                                                                                          ).toFixed(
                                                                                              2,
                                                                                          )
                                                                                        : null}{" "}
                                                                                    {data.C_Color ===
                                                                                    "fancy" ? (
                                                                                        <>
                                                                                            {
                                                                                                data.f_color
                                                                                            }{" "}
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            {
                                                                                                data.C_Color
                                                                                            }{" "}
                                                                                        </>
                                                                                    )}
                                                                                    {
                                                                                        data.C_Clarity
                                                                                    }{" "}
                                                                                    {
                                                                                        data.C_Cut
                                                                                    }{" "}
                                                                                    {
                                                                                        data.C_Polish
                                                                                    }{" "}
                                                                                    {
                                                                                        data.C_Symmetry
                                                                                    }{" "}
                                                                                    {
                                                                                        data.C_Fluorescence
                                                                                    }
                                                                                </span>
                                                                                <div className="font-weight-bold inactive-block">
                                                                                    {
                                                                                        language.CCMODE_THEME1_LIST_MEASUREMENT
                                                                                    }{" "}
                                                                                    :{" "}
                                                                                    {parseFloat(
                                                                                        data.C_Length,
                                                                                    ).toFixed(
                                                                                        2,
                                                                                    )}

                                                                                    x
                                                                                    {parseFloat(
                                                                                        data.C_Width,
                                                                                    ).toFixed(
                                                                                        2,
                                                                                    )}

                                                                                    x
                                                                                    {parseFloat(
                                                                                        data.C_Depth,
                                                                                    ).toFixed(
                                                                                        2,
                                                                                    )}
                                                                                </div>
                                                                                <div className="mb-2 inactive-block">
                                                                                    <span className="font-weight-bold">
                                                                                        T
                                                                                        :
                                                                                    </span>{" "}
                                                                                    {data.C_TableP
                                                                                        ? parseFloat(
                                                                                              data.C_TableP,
                                                                                          ).toFixed(
                                                                                              2,
                                                                                          )
                                                                                        : "00.00"}

                                                                                    %
                                                                                    |{" "}
                                                                                    <span className="font-weight-bold">
                                                                                        D
                                                                                        :
                                                                                    </span>{" "}
                                                                                    {data.C_DefthP
                                                                                        ? parseFloat(
                                                                                              data.C_DefthP,
                                                                                          ).toFixed(
                                                                                              2,
                                                                                          )
                                                                                        : "00.00"}

                                                                                    %
                                                                                </div>
                                                                                <StockStatus
                                                                                    data={
                                                                                        data
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="inactive-block">
                                                                            {!hidePrice && (
                                                                                <>
                                                                                    <div className="text-right">
                                                                                        <p className="text-muted font-weight-bold small mb-0 text-uppercase">
                                                                                            {localStorage.getItem(
                                                                                                "user_currency",
                                                                                            )}
                                                                                            /CT
                                                                                        </p>
                                                                                        <p className="text-dark font-size-lg font-weight-bold">
                                                                                            {isParsable(data.SELECTED_CURRENCY_LIST_PRICE)
                                                                                                ? data.SELECTED_CURRENCY_LIST_PRICE_PER_CARAT_LABEL
                                                                                                : "-"}
                                                                                        </p>
                                                                                    </div>
                                                                                    <div className="text-right">
                                                                                        <p className="text-muted font-weight-bold small mb-0 text-uppercase">
                                                                                            {
                                                                                                language.CCMODE_SHORTLISTPAGE_TOTAL
                                                                                            }
                                                                                        </p>
                                                                                        <div className="text-dark font-size-lg font-weight-bold">
                                                                                            {isParsable(data.SELECTED_CURRENCY_LIST_PRICE)
                                                                                                ? data.SELECTED_CURRENCY_LIST_PRICE_LABEL
                                                                                                : localizePrice(data.SELECTED_CURRENCY_LIST_PRICE, language)}
                                                                                        </div>
                                                                                        <div className="tax-breakdown-subtext">
                                                                                            {data.Tax !== 0
                                                                                                ? data?.taxBreakDown
                                                                                                : ""}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        className={`text-right my-2 small text-capitalize ${
                                                                                            data.Tax ===
                                                                                            0
                                                                                                ? "text-warning"
                                                                                                : "text-success"
                                                                                        }`}
                                                                                    >
                                                                                        {isParsable(
                                                                                            data.SELECTED_CURRENCY_LIST_PRICE,
                                                                                        ) && (data.Tax === 0 || data.taxBreakDown === "") ? (
                                                                                            <em>
                                                                                                {data.Tax ===
                                                                                                0
                                                                                                    ? "* Exclusive tax"
                                                                                                    : `* Inclusive tax`}
                                                                                            </em>
                                                                                        ) : (
                                                                                            ""
                                                                                        )}
                                                                                    </div>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        },
                                                    )
                                                ) : (
                                                    <div>
                                                        {language.CCMODE_CART_NO_RECORDS_IN_CART}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="card gutter-b card-custom">
                                        <div className="card-header">
                                            <div className="card-title">
                                                {language.CCMODE_CART_STONE_DETAILS}(
                                                {selectedstones.length}{" "}
                                                {language.CCMODE_CART_ITEMS})
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-12 d-flex mt-2 font-size-lg justify-content-between font-weight-bold">
                                                    <div className="font-weight-bolder">
                                                        {" "}
                                                        {
                                                            language.SEARCHLIST_TOTALCARAT
                                                        }
                                                        :{" "}
                                                    </div>
                                                    <div>
                                                        {Number(
                                                            totalcarat,
                                                        ).toFixed(2)}
                                                    </div>
                                                </div>
                                                {!hidePrice && (
                                                    <>
                                                        <div className="col-12 d-flex mt-2 font-size-lg justify-content-between font-weight-bold">
                                                            <div className="font-weight-bolder">
                                                                {" "}
                                                                {language.CCMODE_COMMON_TOTAL}{" "}
                                                                {Currency(
                                                                    localStorage.getItem(
                                                                        "user_currency",
                                                                    ),
                                                                )}
                                                                /CT:{" "}
                                                            </div>
                                                            <div>
                                                                {" "}
                                                                {formatCcmodePrice(
                                                                    totalourprice / totalcarat,
                                                                    localStorage.getItem("user_currency"),
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col-12 border-top d-flex mt-2 font-size-h6 justify-content-between font-weight-bold">
                                                            <div className="font-weight-bolder mt-2">
                                                                {
                                                                    language.SEARCHLIST_TOTALPAYABLE
                                                                }{" "}
                                                            </div>
                                                            <div className="mt-2">
                                                                {" "}
                                                                {formatCcmodePrice(
                                                                    totalourprice,
                                                                    localStorage.getItem("user_currency"),
                                                                )}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                                {!hidePrice && displaybuybtn ? (
                                                    <div className="col-12 text-center mt-5 ">
                                                        {planFeatures[
                                                            "buy_request"
                                                        ].allowed === 0 ? (
                                                            <button
                                                                onClick={() =>
                                                                    BuyDiamond()
                                                                }
                                                                disabled={
                                                                    hasPriceOnRequestSelected
                                                                }
                                                                className={`btn font-weight-bold btn-primary mt-2`}
                                                            >
                                                                {language.CCMODE_CART_BUY_DIAMOND}
                                                            </button>
                                                        ) : (
                                                            <button
                                                                onClick={() =>
                                                                    BuyDiamond()
                                                                }
                                                                disabled={
                                                                    hasPriceOnRequestSelected
                                                                }
                                                                className={`btn font-weight-bold btn-primary mt-2`}
                                                            >
                                                                {isBuyRequest
                                                                    ? language.CCMODE_CART_BUY_REQUEST
                                                                    : language.CCMODE_CART_BUY_DIAMOND}
                                                            </button>
                                                        )}
                                                        {hasPriceOnRequestSelected && (
                                                            <div className="text-warning small mt-2">
                                                                {language.CCMODE_CART_PRICE_ON_REQUEST_NO_BUY ||
                                                                    "Price on request items cannot be purchased. Please deselect them to buy."}
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div
                                className="bg-white d-flex align-items-center justify-content-center container rounded"
                                style={{ height: "80vh" }}
                            >
                                <div className="text-center">
                                    <img
                                        className="img-fluid mb-5"
                                        alt="empty-cart"
                                        width="250px"
                                        src={toAbsoluteUrl(
                                            `/media/General/empty-box.jpg`,
                                        )}
                                    />
                                    <div className="font-size-h2 mb-2 font-weight-bold">
                                        {language.CCMODE_CART_YOUR_CART_IS_EMPTY}
                                    </div>
                                    <div className="mb-8">
                                        {language.CCMODE_CART_EMPTY_CART_MESSAGE}
                                    </div>
                                    <span
                                        onClick={backBtn}
                                        className="btn btn-primary btn-pill px-8"
                                    >
                                        {language.CCMODE_CART_GO_BACK_TO_SEARCH}
                                    </span>
                                </div>
                            </div>
                        )
                    ) : (
                        <OrderHistoryOfActiveSession
                            language={language}
                            ConsumerId={ConsumerId}
                        />
                    )}
                </>
            ) : (
                <div
                    className="bg-white d-flex align-items-center justify-content-center container rounded"
                    style={{ height: "80vh" }}
                >
                    <div className="text-center">
                        <CircularProgress color="secondary" />
                    </div>
                </div>
            )}
        </>
    );
};
